module.exports = __webpack_public_path__ + "static/media/Harshul_Image.fd65ce3a.jpg";